import {Component, Input, OnInit, ViewChild} from '@angular/core';
import * as D3 from 'd3';
@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit {

  @ViewChild('labels') private labels;
  svg: any;
  width: number;
  height: number;
  radius: number;
  g: any;
  color: any;
  pie: any;
  pieData: any;
  path: any;

  outerArc: any;
  label: any;
  arc: any;

  polyline: any;
  @Input() hideChartSvg: boolean;
  abc: boolean;

  constructor() {}

  ngOnInit() {
    this.abc = true;
    this.svg = D3.select('svg');
    // console.log('charttttttttttttttttttttttt', this.hideChartSvg);
    this.width = +250;
    this.height = +150;
    // this.radius = Math.min(this.width, this.height) / 2,
    this.radius = 65;
    this.g = this.svg.append('g').attr('transform', 'translate(' + this.width / 2 + ',' + this.height / 2 + ')');
    // this.g = this.svg.append('g').attr('transform', 'translate(' + 200 + ',' + this.height / 2 + ')');
    // console.log('GGGGGGGGGGGGGGGGGGG=', this.g);
    this.color = D3.scaleOrdinal(['#98abc5',
      // '#8a89a6',
      // '#7b6888',
      // '#6b486b',
      // '#a05d56',
      '#d0743c',
      // '#ff8c00',
      // '#e34d01',
      '#ccff05',
      // '#3e7eca',
      // '#aa0092',
      '#b32e4f']);
    this.pie = D3.pie()
      .sort(null)
      .value((d) => d.value);
    this.pieData = [
      {name: 'test', value: 30},
      {name: 'test1', value: 40},
      {name: 'test2', value: 20},
      {name: 'test3', value: 10}
    ];
    this.path = D3.arc()
      .outerRadius(this.radius - 10)
      .innerRadius(0);
    this.outerArc = D3.arc()
      .innerRadius(this.radius * 0.9)
      .outerRadius(this.radius * 0.9);
    this.label = D3.arc()
      .outerRadius(this.radius - 40)
      .innerRadius(this.radius - 40);
    this.appendPath();
  }

  appendPath() {
    this.arc = this.g.selectAll('.arc')
      .data(this.pie(this.pieData))
      .enter().append('g')
      .attr('class', 'arc');
    this.arc.append('path')
      .attr('d', this.path)
      .attr('fill', (d) => { return this.color(d.data.name); });
    this.arc.append('text')
      .attr('transform', (d, i) => {
        const pos = this.outerArc.centroid(d);
        pos[0] = this.radius * (this.midAngle(d) < Math.PI ? 1.1 : -1.1);
        const percent = (d.endAngle - d.startAngle) / (2 * Math.PI) * 100;
        if (percent < 3) {
          pos[1] += i * 15;
        }
        return 'translate(' + pos + ')';
      })
      .text((d) => d.data.name)
      .attr('fill', (d, i) => { return this.color(i); })
      .attr('text-anchor', 'left')
      .attr('dx', (d) => {
        const ac = this.midAngle(d) < Math.PI ? 0 : -50;
        return ac;
      })
      .attr('dy', 5 );
    this.addPolyline();
  }

  addPolyline() {
    this.polyline = this.g.selectAll('polyline')
      .data(this.pie(this.pieData), (d) => {
        return d.data.name;
      })
      .enter()
      .append('polyline')
      .attr('points', (d, i) => {
        const pos = this.outerArc.centroid(d);
        pos[0] = this.radius * 0.95 * (this.midAngle(d) < Math.PI ? 1 : -1);
        const o = this.outerArc.centroid(d);
        const percent = (d.endAngle - d.startAngle) / (2 * Math.PI) * 100;
        if (percent < 3) {
          // o[1];
          pos[1] += i * 15;
        }
        return [this.label.centroid(d), [o[0], pos[1]] , pos];
      })
      .style('fill', 'none')
      .attr('stroke', (d, i) => { return this.color(i); })
      .style('stroke-width', '1px');
  }

  midAngle(d) {
    return d.startAngle + (d.endAngle - d.startAngle) / 2;
  }

}
